import { render, staticRenderFns } from "./BaOperatorAuthorize.vue?vue&type=template&id=7594ad05&scoped=true&"
import script from "./BaOperatorAuthorize.vue?vue&type=script&lang=js&"
export * from "./BaOperatorAuthorize.vue?vue&type=script&lang=js&"
import style0 from "./BaOperatorAuthorize.vue?vue&type=style&index=0&id=7594ad05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7594ad05",
  null
  
)

export default component.exports